import { therapyPlanningAction } from 'src/redux/actions/constant';

const {
    DELETE_SINGLE_MDS_ASSESSMENT_BY_REQUEST,
    DELETE_SINGLE_MDS_ASSESSMENT_BY_SUCCESS,
    DELETE_SINGLE_MDS_ASSESSMENT_BY_FAILURE,
    DELETE_SINGLE_MDS_ASSESSMENT_BY_RESET,
    DELETE_SINGLE_MDS_ASSESSMENT_BY_LOADING,
} = therapyPlanningAction;

const intitialstate: object = {
  response: null,
  loading: false,
  isMdsAssessmentDeleted: false,
};

export const deleteSingleMdsAssessmentReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case DELETE_SINGLE_MDS_ASSESSMENT_BY_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        loading: false,
        isMdsAssessmentDeleted: true,
      };
    }

    case DELETE_SINGLE_MDS_ASSESSMENT_BY_FAILURE:
      return {
        ...state,
        response: action.payload,
        loading: false,
        isMdsAssessmentDeleted: false,
      };
    case DELETE_SINGLE_MDS_ASSESSMENT_BY_LOADING:
      return {
        ...state,
        loading: true,
      };

    case DELETE_SINGLE_MDS_ASSESSMENT_BY_RESET:
      return intitialstate;

    default:
      return state;
  }
};
